import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { EmploymentModel } from 'src/app/model/employer.model';

export const RequestAction = createAction('[Employment History view] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Employment History view] set data',  props<{ payload: EmploymentModel[] }>());



